import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import "../styles/MemberLogin.css";
import { Link, useNavigate } from "react-router-dom";
import { restrictionConfig } from "../constants/restrictionConfig";
import RestrictionModal from "../components/RestrictionModal";

const MemberLogin = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showRestrictionModal, setShowRestrictionModal] = useState(false);

  const storedUser = localStorage.getItem("user");
  const parsedUser = storedUser ? JSON.parse(storedUser) : null;
  const currentUserName = parsedUser?.name || "User";

  const handleRegisterClick = (path) => {
    if (restrictionConfig.isApplicationPaused) {
      setShowRestrictionModal(true);
    } else {
      navigate(path);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);

    try {
      const rolebasedUrl = process.env.REACT_APP_API_BASE_ROLE;
      console.log("Role-based URL:", rolebasedUrl);
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_ROLE}/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await response.json();
      console.log("Login Response:", data);
      if (!response.ok) {
        // Handle specific error messages
        if (data.message === "Incorrect current password") {
          setErrorMsg("Incorrect current password");
        } else if (data.message === "User not found") {
          setErrorMsg("User account not found. Please login again.");
        } else if (data.message === "User not authenticated") {
          setErrorMsg("Session expired. Please login again.");
        } else if (data.message === "Invalid ID") {
          setErrorMsg("User account not found. Please try logging in again.");
        } else {
          setErrorMsg(data.message || "Login failed");
        }
      } else {
        // Store token and user data locally (for landing page use)
        // localStorage.setItem("token", data.token);
        // localStorage.setItem("user", JSON.stringify(data.user));

        console.log();

        // if (
        //   data.user &&
        //   (data.user.rolename === "admin" || data.user.isAdmin)
        // ) {
        //   const adminurl = process.env.REACT_APP_API_ADMIN;
        //   console.log("admin  URL:", adminurl);
        //   const userParam = encodeURIComponent(JSON.stringify(data.user));
        //   window.location.href = `${process.env.REACT_APP_API_ADMIN}/dashboard?token=${data.token}&user=${userParam}`;
        // } else if (data.user && data.user.rolename === "EDCC") {
        //   navigate("/", {
        //     state: { user: data.user, token: data.token },
        //   });
        // } else if (data.user && data.user.rolename === "AssociateMember") {
        //   navigate("/", {
        //     state: { user: data.user, token: data.token },
        //   });
        // } else if (data.user && data.user.rolename === "LifeMember") {
        //   navigate("/", {
        //     state: { user: data.user, token: data.token },
        //   });
        // } else {
        //   navigate("/");
        // }

         if (data.success ===  true) {

          const expiryTimestamp = new Date(data.signin_otp_expiry).getTime();

          localStorage.setItem("otpExpiry", expiryTimestamp);
          
          navigate("/otpmember", {
            state: {email: data.email },
          });
        } else {
          navigate("/");
        }



        //   else {
        //     // Check if user is admin/has access to admin panel
        //     if (
        //       data.user &&
        //       (data.user.rolename === "SuperAdmin" || data.user.rolename === "Secretary" || data.user.rolename === "Admin" || data.user.rolename === "Treasurer" || data.user.rolename === "President")
        //     ) {

        //         const adminurl = process.env.REACT_APP_API_ADMIN ;
        // console.log("admin  URL:", adminurl);
        //       // Redirect to admin template with token and user data
        //       const userParam = encodeURIComponent(JSON.stringify(data.user));
        //       window.location.href = `${process.env.REACT_APP_API_ADMIN}/index?token=${data.token}&user=${userParam}`;
        //     } else {
        //       navigate("/user-dashboard");
        //       // Regular user - stay on landing page or redirect to user dashboard
        //       // navigate("/"); // or wherever regular users should go
        //     }
        //   }
      }
    } catch (err) {
      console.error("Login error:", err);
      setErrorMsg("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="member-login-section">
      <Container>
        <div className="login-box">
          <Row>
            <Col md={6} className="login-left mb-4 mb-md-0">
              <div className="login-form-container">
                <h4 className="login-title">Member Login</h4>
              </div>
            </Col>

            <Col md={6}>
              <Form onSubmit={handleLogin}>
                {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}

                <Form.Group controlId="formEmail" className="mb-4">
                  <Form.Label>Your Email ID</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formPassword" className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <div style={{ position: "relative" }}>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <span
                      onClick={() => setShowPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        right: 10,
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        zIndex: 2
                      }}
                      aria-label={showPassword ? "Hide password" : "Show password"}
                      tabIndex={0}
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                  </div>
                </Form.Group>

                <div className="d-flex justify-content-between align-items-center mb-4">
                  <Link to="/forgot-password" className="custom-link">
                    Forgot Password ?
                  </Link>
                  <Form.Check
                    type="checkbox"
                    label="Remember Me"
                    className="remember-me"
                  />
                </div>

                <div className="text-center mb-3">
                  <Button
                    className="custom-btn"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Signing In..." : "SIGN IN"}
                  </Button>
                </div>

                <div className="bottom-text">
                  Click here to{" "}
                  <span
                    className="custom-link"
                    onClick={() => handleRegisterClick("/terms-conditions")}
                    style={{ cursor: "pointer" }}
                  >
                    Register
                  </span>
                </div>
                <div className="bottom-text" style={{ marginTop: "10px" }}>
                  Click{" "}
                  <span
                    className="custom-link"
                    onClick={() => handleRegisterClick("/old-member-terms-conditions")}
                    style={{ cursor: "pointer", color: "#002bbb" }}
                  >
                    here
                  </span>{" "}
                  if you are an old member without credentials
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>

      <RestrictionModal
        show={showRestrictionModal}
        onHide={() => setShowRestrictionModal(false)}
        title={restrictionConfig.popupTitle}
        message={restrictionConfig.popupMessage}
        buttonText={restrictionConfig.buttonText}
        userName={currentUserName}
      />
    </section>
  );
};

export default MemberLogin;